import React from 'react';
import { Result, Button, Space } from 'antd';
import { Link } from 'react-router-dom';
import { HomeOutlined, LeftOutlined } from '@ant-design/icons';
import './index.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <Result
        status="404"
        title="404"
        subTitle="抱歉，您访问的页面不存在。"
        extra={
          <Space size="middle">
            <Button type="primary">
              <Link to="/">
                <HomeOutlined /> 返回首页
              </Link>
            </Button>
            <Button onClick={() => window.history.back()}>
              <LeftOutlined /> 返回上一页
            </Button>
          </Space>
        }
      />
    </div>
  );
};

export default NotFound;